// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.image-background[data-v-6ad71524] {\n  margin: 0;\n  padding: 0;\n  height: 80vh;\n  background-image: url(\"https://silkplm.com/wp-content/uploads/2024/05/Background-1.svg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-attachment: fixed;\n  background-position: center;\n}\n", ""]);
// Exports
module.exports = exports;
